import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Views } from "react-big-calendar";
import { useResourceCalendarView } from "@/components/resource-big-calendar/ResourceCalendarViewContext";
import type { HouseVisitSlotCalendarEvent } from "./types";

function buildTooltip(event: HouseVisitSlotCalendarEvent): string {
  const parts = [
    event.resource.label?.trim() || "Day slot",
    `${event.stopCount}/${event.capacity} stops`,
  ];
  return parts.filter(Boolean).join(" · ");
}

export function HouseVisitSlotCalendarEventComponent({
  event,
}: {
  event: HouseVisitSlotCalendarEvent;
}) {
  const muiTheme = useTheme();
  const view = useResourceCalendarView();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"), { noSsr: true });
  const tooltip = buildTooltip(event);
  const counts = `${event.stopCount}/${event.capacity}`;
  const label = event.resource.label?.trim();

  if (view === Views.MONTH) {
    const line = label ? `${label} · ${counts}` : counts;
    return (
      <Box
        title={tooltip}
        sx={{
          color: "inherit",
          px: 0,
          py: 0,
          minWidth: 0,
          width: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          fontSize: isMobile ? "0.65rem" : "0.7rem",
          lineHeight: 1.2,
          fontWeight: 600,
        }}
      >
        {line}
      </Box>
    );
  }

  return (
    <Box
      title={tooltip}
      sx={{
        color: "inherit",
        p: 0,
        minWidth: 0,
        width: "100%",
        overflow: "hidden",
        fontSize: isMobile ? "0.68rem" : "0.75rem",
        lineHeight: 1.25,
      }}
    >
      <Typography
        variant="caption"
        component="div"
        sx={{
          fontWeight: 700,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "block",
        }}
      >
        {label || "House visits"}
      </Typography>
      <Typography
        variant="caption"
        component="div"
        sx={{
          opacity: 0.95,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {counts} stops
      </Typography>
    </Box>
  );
}
